import styled, { css } from 'styled-components';
import { InfiniteList } from '../../molecules/InfiniteList';

export const Row = styled.div<{ $selectable?: boolean }>`
  display: table-row;
  cursor: ${({ $selectable }) => ($selectable ? 'pointer' : null)};
  transition: background-color 0.2s;
  height: 1rem;

  &:hover {
    background-color: ${({ theme, $selectable }) =>
      $selectable ? theme.colors.lightestGray : null};
  }
`;

const Cell = styled.div`
  display: table-cell;
  word-break: break-word;
  padding: 1rem 2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};

  ${({ onClick }) =>
    onClick &&
    css`
      &:hover {
        cursor: pointer;
      }
    `}
`;

export const Table = {
  Container: styled.div`
    display: table;
    background-color: ${({ theme }) => theme.colors.white};
    width: 100%;
    max-width: 120rem;
    table-layout: fixed;
  `,

  Row,

  HeaderRow: styled(Row)``,

  Cell,

  HeaderCell: styled(Cell)`
    font-weight: bold;
    border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
  `,

  Actions: styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.5rem;

    > div {
      width: 20rem;
    }
  `,

  Message: styled.p<{ $invisible?: boolean }>`
    text-align: center;
    opacity: ${({ $invisible }) => ($invisible ? 0 : 1)};
  `,

  Body: styled(InfiniteList)`
    display: table-row-group;
  `,

  Loading: styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    margin-right: 1rem;
  `,
};
